import React from 'react'

const Comment = () => {
  return (
    <div>
      <h1>
      this is Comment
      </h1>
    </div>
  )
}

export default Comment
